
import React from 'react';
import {goCommonPage} from '@modules/58m';
import {setlog} from "@modules/58m";
import prdApi from "@config/api";
export default (props)=>{
    function jump(){
      setlog("mchatbot_cvip_click");
      goCommonPage(prdApi.jumpUrl.yycvip)
    }

    return (
        <div className="chatpanel-item chatpanel-item-card-yy">
        <div className="item-container">
          <div className="item-content" onClick={jump}>
            <div className="item-pic"></div>
            <div className="item-main-title">开通VIP黄金会员卡</div>
            <div className="item-subtitle">没有效果，58包赔！</div>
          </div>
        </div>
      </div>
    )
}